import useMediaQuery from '@cartwhl/ui/hooks/useMediaQuery';

export default function useTruncateText(
  text: string,
  limits?: { mobile: number; tablet: number; desktop: number },
) {
  const isMobile = useMediaQuery('(max-width: 640px)');
  const isTablet = useMediaQuery('(min-width: 641px) and (max-width: 1024px)');

  const limit = isMobile
    ? limits?.mobile ?? 40
    : isTablet
      ? limits?.tablet ?? 80
      : limits?.desktop ?? 120;

  return text.length > limit ? `${text.slice(0, limit)}...` : text;
}
